import { lms_v2_api } from "../../../services/cs-lab-config"

function analyzeCodeComplexity(payload) {
    return lms_v2_api.post("/ideProjects/analyzeComplexity/",payload);
}

export { analyzeCodeComplexity }